module.exports = __webpack_public_path__ + "static/img/copyright@2x.9f66e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/copyright@2x.png
// module id = vA1I
// module chunks = 1